import { DataManager, Query } from '@syncfusion/ej2-data';
import { Column, IGrid } from "@syncfusion/ej2-angular-grids";
import { FieldEditChangedArgs, FieldMetadata } from "../cer-data/cer-data-types";
import { isEditable, getObject, getComplexFieldID, NumericEditCell } from "@syncfusion/ej2-grids";
import { ColorPicker } from '@syncfusion/ej2-angular-inputs';

export class CerGridEditColorPicker {
  private grid: any;
  private column: Column;
  private rowData: Object;
  private requestType: string;
  private fieldMeta: FieldMetadata;
  private fieldsMeta: FieldMetadata[];
  private baseEditCellAny: any;
  private element: Element;
  private input: HTMLInputElement;
  private obj: ColorPicker;
  private originalValue: any;
  private baseQuery: Query;

  constructor(grid: IGrid, baseEditCell: NumericEditCell, 
    fieldMeta: FieldMetadata, fieldsMeta: FieldMetadata[]) {
    this.grid = grid;
    this.baseEditCellAny = <any>baseEditCell;
    this.fieldMeta = fieldMeta;
    this.fieldsMeta = fieldsMeta;

    (<any>baseEditCell).create_orig = baseEditCell.create;
    baseEditCell.create = this.create.bind(this);

    (<any>baseEditCell).destroy_orig = baseEditCell.destroy;
    baseEditCell.destroy = this.destroy.bind(this);

    //(<any>baseEditCell).write_orig = baseEditCell.write;
    baseEditCell.write = this.write.bind(this);

    (<any>baseEditCell).read_orig = baseEditCell.read;
    baseEditCell.read = this.read.bind(this);
  }

  public create(args: any): any {
    this.input = this.baseEditCellAny.create_orig(args);
    return this.input;
  }

  public write(args: {
    rowData: Object; element: Element; column: Column; row: HTMLElement;
    requestType: string; foreignKeyData?: Object[]
  }) {
    this.rowData = args.rowData;
    this.element = args.element;
    this.column = args.column;
    this.fieldMeta = (<any>this.column).meta;
    this.requestType = args.requestType;
    
    this.baseEditCellAny.column = this.column;

    if (this.rowData && this.fieldMeta.name) {
      this.originalValue = (<any>args.rowData)[this.fieldMeta.name];
    }

    this.writePicker();

    this.addEventListener();
    this.obj.appendTo(<any>this.element);
    this.element.setAttribute('name', getComplexFieldID(this.column.field));
  }

  public destroy() {
    if (this.baseEditCellAny.destroy_orig) {
      return this.baseEditCellAny.destroy_orig();
    }
    this.removeEventListener();
  }

  public read(element: Element): number {
    if (this.baseEditCellAny.read_orig) {
      const value = this.baseEditCellAny.read_orig(element);
      if (value?.length > 1) {
        return parseInt(value.substring(1), 16);
      }
    }
    return null;
  }

  private writePicker(): any {
    let isInline: boolean = this.grid.editSettings.mode !== 'Dialog';
    const fieldValue = getObject(this.column.field, this.rowData);
    const valueHex = fieldValue ? "#" + fieldValue.toString(16) : null;
    let params: any = {
      fieldMeta: this.fieldMeta,
      baseQuery: this.baseQuery,
      dataSource: this.dataSourceGet(),
      //enableVirtualization: true,
      fields: { text: this.column.foreignKeyValue, value: this.column.foreignKeyField },
      enabled: isEditable(this.column, this.requestType, this.input),
      mode: 'Palette',
      value: valueHex,
      enableRtl: this.grid.enableRtl,
      preventAutoFill: true,
      placeholder: isInline ? '' : this.column.headerText,
      floatLabelType: isInline ? 'Never' : 'Always',
      cssClass: this.grid.cssClass ? this.grid.cssClass : null,
      close: this.dropDownClose.bind(this)
    };
    if (this.column.edit.params) {
      var paramsAny: any = this.column.edit.params;
      var keys = Object.keys(this.column.edit.params);
      for (var i = 0; i < keys.length; i++) {
        var key: string = keys[parseInt(i.toString(), 10)];
        params[key] = paramsAny[key] === 'query' ? (paramsAny[key]).clone() : paramsAny[key];
      }
    }
    this.obj = new ColorPicker(params); // new DropDownList(params);
    //this.obj.updateVirtualizationProperties(50,true);
  }

  private dataSourceGet(): any {
    let ds: any = this.column.dataSource;
    let dsData: any = ds?.dataSource;

    let dataArray: Object[] = null;

    let isJsonData = dsData != null && dsData.dataType == 'json' && Array.isArray(dsData.json);
    if (isJsonData) {
      dataArray = dsData.json;
    }
    if (dataArray == null || dataArray.length == 0) {
      if (Array.isArray(ds) && ds.length > 0) {
        dataArray = ds;
      }
    }
    if (dataArray == null || dataArray.length == 0) {
      if (this.fieldMeta?.foreignKey?.data != null && Array.isArray(this.fieldMeta.foreignKey.data)) {
        dataArray = this.fieldMeta.foreignKey.data;
      }
    }

    if (dataArray != null && dataArray.length > 0) {
        return new DataManager(dataArray.slice(0));
    }
    else {
      return this.column.dataSource;
    }
    //data: this.fieldMeta?.foreignKeyData ? this.fieldMeta.foreignKeyData : this.column?.dataSource instanceof DataManager ? (this.column.dataSource as DataManager)?.dataSource?.json : this.column.dataSource as any[],
  }

  private addEventListener() {
    if (this.input) {
      this.obj.addEventListener("select", this.onSelect.bind(this));
      this.obj.addEventListener("change", this.onEditChanged.bind(this));

    }
  };

  private removeEventListener() {
    this.obj.removeEventListener("change", this.onEditChanged.bind(this));
    this.obj.removeEventListener("select", this.onSelect.bind(this));
  }


  private dropDownClose(args: any) {
    if (args.event && args.event.action === 'escape') {
      this.grid.editModule.editCellDialogClose = false;
    }
  }

  // ** to-do: validate select args.cancel = true
  private onSelect(args: any) {
    if (this.fieldMeta?.onEditChanging) {
      this.fieldMeta.onEditChanging(args);
      /*
      if (args?.cancel === true && this.obj) {
        var previousValue = null;
        var previousInputValue = null;
        var objAny : any = this.obj;
        var prevData : any = objAny.previousItemData;
        if (prevData && this.fieldMeta?.foreignKeyValue) {
          previousValue = prevData[this.fieldMeta.foreignKeyField];
          previousInputValue = prevData[this.fieldMeta.foreignKeyValue];
        }
        if (this.obj.value != this.originalValue) {
          this.obj.value = previousValue;
            this.input.value = previousInputValue;
        }
      */
    }
  }

  private onEditChanged(args: any) {
    if (this.fieldMeta?.onEditChanged) {
      var changedArgs: FieldEditChangedArgs = {
        editService: this.grid?.cerGrid?.editService,
        field: this.fieldMeta?.name,
        fieldMeta: this.fieldMeta,
        fieldsMeta: this.fieldsMeta,
        value: args.value,
        data: this.rowData,
        itemData: args.itemData,
        previousValue: this.originalValue,
        previousData: args.previousData,
        args: args
      };
      this.fieldMeta.onEditChanged(changedArgs);
    }
    this.validate();
  }

  public validate() {
    /*
    setTimeout(() => {
      this.grid?.editModule?.editFormValidate();
    }, 1);
    */
  }

}
